var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7379_23670",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18400",
    x: 0.5,
    y: 0.632812,
    width: 32.5,
    height: 32.5,
    rx: 16.25,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7379_23670)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 295147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.3121 0.632812H3.43555V33.1328H39.3121V0.632812Z",
    fill: "#2A6238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.31092 0.632812H-5.8125V33.1328H8.31092V0.632812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.015 11.5806L23.515 13.3108L25.7018 12.4813L24.4454 14.3818L25.9454 16.112L23.6669 15.5549L22.4106 17.4553L22.2619 15.2113L19.9834 14.6572L22.1669 13.8246L22.015 11.5806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.5026 23.2743C17.1798 23.2743 13.6766 19.9222 13.6766 15.7869C13.6766 11.6517 16.9108 8.57504 20.9994 8.32432C20.7874 8.30885 20.5722 8.29956 20.357 8.29956C15.4045 8.29956 11.3887 12.1408 11.3887 16.8796C11.3887 21.6184 15.4045 25.4596 20.357 25.4596C25.3096 25.4596 29.3254 21.6184 29.3254 16.8796C29.3254 16.6722 29.3159 16.4679 29.3001 16.2667C29.0406 20.176 25.6513 23.2712 21.4994 23.2712L21.5026 23.2743Z",
    fill: "white"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/pk.e2e80d2048f4ea51185fa8b4d830c7c7.svg";
export { ForwardRef as ReactComponent };